// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

    /* Start-Boost-Fix-Price */
  InstantSearchApi.beforeCall = function(searchTerm) {
      Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
      Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
      Globals.instantSearchQueryParams.return_all_currency_fields = false;
  }
  /* End-Boost-Fix-Price */
})();